module.exports = __webpack_public_path__ + "mall.png?89e84ea02dbdde0731a37fe75b4e7c7e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall.png
// module id = 976
// module chunks = 2